import { EnumSiNoTodos, FilterSearchingBaseViewModel, PagingResultsViewModel } from '../../../core/_infrastructure/types/common';

export class TratamientoDesinfeccionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TTratamientoItemViewModel[];
}

export class FilterSearchingTTratamientoCamViewModel extends FilterSearchingBaseViewModel {
    //los campos del filtro
    public IdCampania: number;
    public IdPais: number;
    public Tratamiento: string;
    public Activo: number = EnumSiNoTodos.TODOS;
}

export class TTratamientoCamViewModel {
    // los campos  de la tabla de la DBO
    public Id: number;
    public IdCampania: number;
    public FechaCreacion: Date;
    public FechaBaja: Date;
    public Tratamiento: string;
    public ProductoQuimico: string;
    public Concentracion: string;
    public Duracion: number;
    public Temperatura: string;
    public Fecha: Date;
    public InformacionAdicional: string;
    public Activo = false;
}

export class TTratamientoItemViewModel {
    public Id: number;
    public IdCampaniaDescripcion: string;
    public IdPaisDescripcion: string;
    public FechaCreacion: Date;
    public FechaBaja: Date;
    public Tratamiento: string;
    public ProductoQuimico: string;
    public Concentracion: string;
    public Duracion: number;
    public Temperatura: string;
    public Fecha: Date;
    public InformacionAdicional: string;
    public Activo: number;
}
